import { CustomMenu } from './../../../interfaces/DisplayInterfaces';

import { Params } from '@angular/router';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewChecked, HostListener} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DisplayStateService, CacheConstants, Events } from '../../../services/DisplayStateService';
import { ClientSettingsService } from '../../../services/ClientSettingsService';
import { NameValue } from '../../../interfaces/WidgetInterfaces';
import { WindowUtils } from '../../../classes/UtilityFunctions';

@Component({
  selector: 'app-top-nav',
  template: `<nav class="navbar navbar-toggleable-md fixed-top bg-primary">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="d-flex">
        <a class="navbar-brand" (click)="toggleNav()" href="javascript:;">
            <i class="fa fa-bars" aria-hidden="true" title="Toggle sidebar visibility"></i>
            <span class="sr-only">Toggle sidebar visibility</span>
        </a>
        <a class="navbar-brand" [platformRouterLink]="{}">{{appName}}</a>
    </div>
    <div class="navbar-collapse collapse" id="navbarNav">
        <ul class="navbar-nav flex-row mr-auto justify-content-between">
            <li class="nav-item dropdown custom-dropdown" *ngIf="!hideLayoutMenu">
                <a href="javascript:;" class="nav-link dropdown-toggle" id="layout" data-toggle="dropdown">Layout</a>
                <div class="dropdown-menu" aria-labelledby="layout">
                    <a class="dropdown-item" (click)="toggleFullScreen()">Full Screen  <i class="fa fa-check pull-right" *ngIf="fullScreen"></i></a>

                    <div class="dropdown-submenu">
                        <button class="dropdown-item" data-toggle="dropdown">Page</button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" (click)="Refresh()" href="javascript:;">Refresh</a>
                            <a class="dropdown-item" (click)="ConfigureWidgetLayout()" href="javascript:;">Configure Widget Layout</a>
                            <a class="dropdown-item" (click)="RefreshWidgetConfiguration()" href="javascript:;">Refresh Widgets</a>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-header">Widgets Per Row</div>
                            <div *ngFor="let perRow of widgetsPerRowList">
                                <a class="dropdown-item" href="javascript:;" (click)="SetWidth(perRow.name)">
                                {{perRow.name}}
                                <i class="fa fa-check" *ngIf="PerRow(perRow.name)"></i>
                              </a>
                            </div>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-header">Quick Links</div>
                            <a class="dropdown-item" href="javascript:;" (click)="QuickLink('widgetstore')">Widget store</a>
                            <a class="dropdown-item" href="javascript:;" (click)="QuickLink('diagnostics')">Diagnostics</a>
                            <a class="dropdown-item" href="javascript:;" (click)="QuickLink('cachedatareport')">Cached Data Report</a>
                        </div>
                    </div>
                    <div *ngIf="themePaths?.length" class="dropdown-submenu">
                        <button class="dropdown-item" data-toggle="dropdown">Themes</button>
                        <div class="dropdown-menu">
                            <a *ngFor="let theme of themePaths" class="dropdown-item" (click)="ChangeTheme(theme.name)" href="javascript:;">
                               {{theme.name}} <i class="fa fa-check pull-right" *ngIf="currentTheme == theme.name"> </i>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
            <!-- Cache Section Wrapper  -->
            <li class="nav-item dropdown custom-dropdown" *ngIf="!hideCacheMenu">
                <a class="nav-link dropdown-toggle" href="javascript:;" id="cache" data-toggle="dropdown">Cache</a>
                <div class="dropdown-menu" aria-labelledby="cache">
                    <div *ngFor="let policy of cachePolicyList">
                        <a class="dropdown-item" href="javascript:;" (click)="SetCachePolicy(policy.name)">{{policy.value}} <i class="fa fa-check" *ngIf="CachePolicyIs(policy.name)"></i></a>
                    </div>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:;" (click)="ClearLocalCache()">Clear Local Cache</a>
                </div>
            </li>
            <!-- End of Cache Section Wrapper  -->
            <li *ngIf="isAdmin" class="nav-item dropdown custom-dropdown">
                <a class="nav-link dropdown-toggle" href="javascript:;" id="admin" data-toggle="dropdown">Admin</a>
                <div class="dropdown-menu" aria-labelledby="admin">
                    <a class="dropdown-item" (click)="QuickLink('platformconfig')" href="javascript:;">Platform Configuration</a>
                    <a class="dropdown-item" (click)="SetAdminRights(false)" href="javascript:;">Set Admin Off</a>
                    <a class="dropdown-item" (click)="SetAdminRights(true)" href="javascript:;">Set Admin On</a>
                    <a class="dropdown-item" (click)="RaiseAToast()" href="javascript:;">Raise a toast</a>
                </div>
            </li>
            <div *ngIf="CustomMenus && CustomMenus.length > 0">
                <li *ngFor="let menu of CustomMenus" class="nav-item dropdown custom-dropdown">
                    <a class="nav-link dropdown-toggle" href="javascript:;" data-toggle="dropdown">{{menu.name}}</a>
                    <div class="dropdown-menu">
                        <a *ngFor="let item of menu.menuItems" class="dropdown-item" (click)="item.handler()" href="javascript:;">{{item.name}}</a>
                    </div>
                </li>
            </div>
            
        </ul>
        <!-- Users field  -->
        <div class="my-2 hidden-sm-down">
            <input *ngIf="!isPrintModeOn && !hidePrintLayout" type="button" class="btn btn-sm btn-info topnav-print" value="Print Layout" (click)="onPrintPreviewMode()"/>
            <div *ngIf="isPrintModeOn && !hidePrintLayout" class="btn-group btn-group-sm topnav-print" role="group" aria-label="Small button group"> 
                <button type="button" (click)="onPrint()" class="btn btn-success topnav-print">Print</button> 
                <button type="button" (click)="onPrintCancel()" class="btn btn-warning topnav-print">Cancel</button> 
            </div>
            <span *ngIf="showNoChromeMessage" class="badge badge-danger">Not Using Chrome !! </span>
             <img class="img-circle" src="http://bomysite.micron.com:80/User%20Photos/Profile%20Pictures/{{MicronUserName}}_MThumb.jpg"/> 
             <span *ngIf="MicronUserName; else NotLoggedIn" class="navbar-text">Signed in as {{MicronUserName}}</span> 
            <span *ngIf="isAdmin" class=" navbar-text">(Admin)</span>
            <ng-template #NotLoggedIn>
                <span class=" navbar-text">Obtaining user credentials...</span>
            </ng-template>
        </div>
        <!-- End of Users field  -->
    </div>
</nav>

<div class="scroll-to-top" *ngIf="showScrollTotop" (click)="smoothScrollTotop()">
    <i class="fa fa-chevron-up" aria-hidden="true"></i>
</div>`,
  styles: [`.alert-msg{
    height:40px;
    margin:0px 0px;
}

#navbars{
    cursor:pointer;
}

.navbar-text{
    padding:0;
}

.dropdown-submenu{
    position:relative;
}

.dropdown-submenu>.dropdown-menu{
    top:0;
    left:100%;
    margin-top:-6px;
    margin-left:0;
    border-radius:0.25rem;
}

.dropdown-submenu:hover>.dropdown-menu{
    display:block;
}

.dropdown-submenu>a::after{
    border-bottom:0.3em solid transparent;
    border-left-color:inherit;
    border-left-style:solid;
    border-left-width:0.3em;
    border-top:0.3em solid transparent;
    content:" ";
    display:block;
    float:right;
    height:0;
    margin-right:-0.6em;
    margin-top:-0.95em;
    width:0;
}

.dropdown-submenu.pull-left{
    float:none;
}

.dropdown-submenu.pull-left>.dropdown-menu{
    left:-75%;
}

.dropdown-menu .divider{
    background-color:#e5e5e5;
    height:1px;
    margin:9px 0;
    overflow:hidden;
}

.topnav-print{
    padding:0 7px !important;
}

.img-circle{
    border-radius:35px;
    height:35px;
    margin-right:5px;
}
.custom-dropdown{
    margin-top:7px;
}

.scroll-to-top{
    position:fixed;
    right:65px;
    bottom:50px;
    z-index:9999;
    padding:7px 12px 10px 12px;
    border-radius:20px;
    background:#80808057;
    -webkit-box-shadow:7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    box-shadow:7px 7px 5px 0px rgba(50, 50, 50, 0.75);
  }
  
  .scroll-to-top:hover{
    position:fixed;
    right:65px;
    bottom:50px;
    z-index:9999;
    padding:7px 12px 10px 12px;
    border-radius:20px;
    background:rgba(128, 128, 128, 0.82);
    -webkit-box-shadow:1px 1px 0px 0px rgba(50, 50, 50, 0.75);
            box-shadow:1px 1px 0px 0px rgba(50, 50, 50, 0.75);
  }`]

})
export class TopNavComponent implements OnInit, OnDestroy, AfterViewChecked {
  isBtnActive = true;
  sideNavToggle: boolean;
  noChromeMessage: string;
  statechanged$: Subscription;
  appName = '';
  fullScreen = false;
  User: string;
  MicronUserName: string;
  isAdmin = false;
  themePaths: NameValue[] = [];
  // Flags to hide menu items.
  hideLayoutMenu: boolean;
  hideCacheMenu: boolean;
  hidePrintLayout: boolean;

  currentTheme: string;
  showNoChromeMessage: boolean;
  isPrintModeOn = false;
  showScrollTotop = false;

  CustomMenus: CustomMenu[];
  
  widgetsPerRowList: NameValue[] = [
    { name: '1', value: '' },
    { name: '2', value: '' },
    { name: '3', value: '' },
    { name: '4', value: '' }
  ];

  cachePolicyList: NameValue[] = [
    { name: CacheConstants.DEFAULT, value: 'Use default widget cache policy' },
    { name: CacheConstants.PERMANENT, value: 'Always Use cache' },
    { name: CacheConstants.NEVER, value: 'Never use cache' },
  ];

  @HostListener('window:scroll', [])
  onWindowScroll() {
  const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  if (number > 50) {
    this.showScrollTotop = true;
  } else if (number < 50) {
    this.showScrollTotop = false;
  }
};

  smoothScrollTotop() {
    const scrollDuration = 200;
    const scrollStep = -window.scrollY / (scrollDuration / 50),
    scrollInterval = setInterval( () => {
    if ( window.scrollY !== 0 ) {
        window.scrollBy( 0, scrollStep );
    } else {
      clearInterval(scrollInterval);
    }
  }, 15);
  };

  constructor(
    public DisplayStateService: DisplayStateService,
    private clientSettingsService: ClientSettingsService,
    private cdr: ChangeDetectorRef
  ) {
    this.appName = this.clientSettingsService.ApplicationName || 'Web Platform';
  }

  ngOnInit() {

    this.CustomMenus = this.clientSettingsService.CustomMenus;
    this.themePaths = this.clientSettingsService.ThemePaths;
    this.currentTheme = this.clientSettingsService.CurrentTheme;
    this.hideLayoutMenu = this.clientSettingsService.HideLayoutMenu;
    this.hideCacheMenu = this.clientSettingsService.HideCacheMenu;
    this.hidePrintLayout = this.clientSettingsService.HidePrintLayout;

    if (this.DisplayStateService.appState.current.user !== undefined) {
      var user = this.DisplayStateService.appState.current.user.userName;
      this.User = user;
      this.MicronUserName = user.substring(0, user.indexOf("@"));
      this.isAdmin = this.DisplayStateService.appState.current.userIsAdmin;
    }
    this.statechanged$ = this.DisplayStateService.AppStateChanged.subscribe(x => {
      if (x === Events.USER_CHANGED) {
        var user = this.DisplayStateService.appState.current.user.userName;
        this.User = user;
        this.MicronUserName = user.substring(0, user.indexOf("@"));
        this.isAdmin = this.DisplayStateService.appState.current.userIsAdmin;
      }
      if (x === Events.TITLE_CHANGED) {
        this.appName = this.DisplayStateService.appState.current.appTitle;
      }
    });
    this.handleUnsupportedNavigator();
  }

  ngAfterViewChecked() {
    // to stop ExpressionChangedAfterItHasBeenCheckedError errors by
    // from updating the parent components state from an event coming from a child component.
    this.cdr.detectChanges();
  }

  ChangeTheme(themePath: string) {
    const message: Params = [];
    message['NewThemeRequest'] = themePath;
    this.DisplayStateService.MessageHouse.next(message);
    this.currentTheme = this.clientSettingsService.CurrentTheme;
  }
  toggleSideNav() {
    this.DisplayStateService.ToggleNavDisplay();
    this.isBtnActive = !this.isBtnActive;
  }

  Refresh() {
    location.reload();
  }

  QuickLink(linkName: string) {
    const newContext: Params = [];

    if (linkName.toLowerCase() === 'diagnostics') {
      newContext['Source'] = 'Admin';
      newContext['Category'] = 'Help';
      newContext['Module'] = 'Diagnostics';
      this.DisplayStateService.SetContext(newContext);
    } else if (linkName.toLowerCase() === 'widgetstore') {
      newContext['Source'] = 'Admin';
      newContext['Category'] = 'Actions';
      newContext['Module'] = 'User Config';
      this.DisplayStateService.SetContext(newContext);
    } else if (linkName.toLowerCase() === 'cachedatareport') {
      newContext['Source'] = 'Admin';
      newContext['Category'] = 'Cache';
      newContext['Module'] = 'Cached Data Report';
      this.DisplayStateService.SetContext(newContext);
    } else if (linkName.toLowerCase() === 'platformconfig') {
      newContext['Source'] = 'Admin';
      newContext['Category'] = 'Actions';
      newContext['Module'] = 'Platform Config';
      this.DisplayStateService.SetContext(newContext);
    }
  }

  SetAdminRights(setting: boolean) {
    this.DisplayStateService.appState.current.userIsAdmin = setting;
  }

  ngOnDestroy() {

    this.statechanged$.unsubscribe();
  }

  toggleNav() {
    if (this.DisplayStateService.appState.current.sideNav.displayState === 'show') {
      this.DisplayStateService.RouteSideNavDisplay('hide');
    } else {
      this.DisplayStateService.RouteSideNavDisplay('show');
    }
  }

  toggleFullScreen() {

    this.fullScreen = !this.fullScreen;
    this.DisplayStateService.SetFullScreen(this.fullScreen);
  }

  PerRow(n: number): boolean {
    return this.DisplayStateService.appState.current.perRow === n.toString();
  }

  SetCachePolicy(name: string) {
    this.DisplayStateService.appState.current.cachePolicy = name;
  }

  RaiseAToast() {
    this.DisplayStateService.RaiseToast('Admin menu testing');
  }

  CachePolicyIs(name: string): boolean {
    return this.DisplayStateService.appState.current.cachePolicy === name;
  }
  SetWidth(perRow: string) {
    this.DisplayStateService.RouteWidgetsPerRow(perRow);
  }

  ConfigureWidgetLayout() {
    const messageParams: Params = [];
    messageParams[`ShowConfigureWidgetLayout`] = '';
    this.DisplayStateService.MessageHouse.next(messageParams);
  }

  ClearLocalCache() {
    this.DisplayStateService.ClearLocalCache();
  }

  RefreshWidgetConfiguration() {
    this.DisplayStateService.LoadWidgetConfigList();
  }

  onPrintPreviewMode(): void {
    this.DisplayStateService.EnablePrintMode(true);
    this.isPrintModeOn = true;
  }

  onPrint(): void {
    window.print();
    this.DisplayStateService.EnablePrintMode(false);
    this.isPrintModeOn = false;
  }
  onPrintCancel(): void {
    this.DisplayStateService.EnablePrintMode(false);
    this.isPrintModeOn = false;
  }

  private handleUnsupportedNavigator(): void {
    let $win = WindowUtils.getNativeWindowObject();
    this.showNoChromeMessage = !(/Chrome/.test($win.navigator.userAgent) && /Google Inc/.test($win.navigator.vendor));
    if (this.showNoChromeMessage) {
      this.DisplayStateService.RaiseWarnToast('We recommend you to use chrome for this appplication !!');
    }
  }
}
